import { useTranslation } from 'react-i18next';
import HeadingIcon from '@assets/icons/heart-handshake.svg?react';

import CLogo1 from '@assets/customer_logos/marti.png';
import CLogo2 from '@assets/customer_logos/zugestates.png';
import CLogo3 from '@assets/customer_logos/sbb.png';
import CLogo5 from '@assets/customer_logos/sps.png';
import CLogo6 from '@assets/customer_logos/stadtthun.png';
import CLogo7 from '@assets/customer_logos/hrs.png';
import CLogo8 from '@assets/customer_logos/stadtzuerich.png';
import CLogo9 from '@assets/customer_logos/swisslife.png';

export const Customers = () => {
    const { t } = useTranslation();

    return (
        <section
            id="customers"
            className="w-full py-8 md:py-12 bg-sectbg1"
        >
            <div className="max-w-[1280px] mx-auto px-8">
                {/* Grid: 1 column on mobile/tablet, 3 columns on desktop */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
                    {/* Column 1: Heading */}
                    <div className="lg:col-span-1">
                        <h2 className="text-4xl font-bold text-secttxthead tracking-tight flex items-center gap-x-4">
                            <HeadingIcon className="h-9 w-auto" />
                            <span>{t('nav.customers')}</span>
                        </h2>
                    </div>

                    {/* Column 2: Content (spans 2 of 3 columns on desktop) */}
                    <div className="lg:col-span-2">
                        <p className="text-lg text-secttxtprim">
                            {t('customers.intro')}
                        </p>
                        <ul className="text-lg mt-6 space-y-3 text-secttxtprim list-disc pl-6">
                            <li>
                                {t('customers.type1')}
                            </li>
                            <li>
                                {t('customers.type2')}
                            </li>
                            <li>
                                {t('customers.type3')}
                            </li>
                            <li>
                                {t('customers.type4')}
                            </li>
                            <li>
                                {t('customers.type5')}
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Customer logos */}
                <div className="pt-8 md:pt-12">
                    <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-8 lg:gap-x-12 lg:gap-y-10
                    [&>img]:grayscale [&>img]:opacity-75">
                        <img src={CLogo1} className="h-7 w-auto lg:h-9" />
                        <img src={CLogo2} className="h-auto w-22 lg:w-28" />
                        <img src={CLogo3} className="h-7 w-auto lg:h-9" />
                        <img src={CLogo5} className="h-7 w-auto lg:h-9" />
                        <img src={CLogo6} className="h-7 w-auto lg:h-9" />
                        <img src={CLogo7} className="h-7 w-auto lg:h-9" />
                        <img src={CLogo8} className="h-auto w-28 lg:w-36" />
                        <img src={CLogo9} className="h-7 w-auto lg:h-9" />
                    </div>
                </div>

            </div>
        </section>
    );
};